import React, { useState } from 'react'

import './styles.scss'
import SaveToastNotification from 'utils/toasts/SaveToastNotification'
import IconButton from 'components/forms/IconButton'
import EyeIcon from 'components/icons/EyeIcon'
import EyeSlashIcon from 'components/icons/EyeSlashIcon'
import CopyIcon from 'components/icons/CopyIcon'
import InputLabel from 'components/forms/InputLabel'

/**
 * Input text
 * @param {object} props
 * @param {function} props.onChange
 * @param {string} [props.value]
 * @param {boolean} [props.disabled]
 * @param {boolean} [props.required]
 * @param {string} [props.className]
 * @param {string} [props.placeholder]
 * @param {string} [props.htmlFor]
 * @param {string} [props.title]
 * @param {boolean} [props.displayEdit]
 * @param {function} [props.onClickEdit]
 * @param {boolean} [props.hiddenEye]
 * @param {boolean} [props.hiddenCopy]
 *
 * @returns {React.Component}
 */
const InputPassword = (props) => {
  const {
    value = '', onChange, disabled = false,
    className = '', placeholder = null, required = false,
    htmlFor = null, title = '', onClickEdit, displayEdit = false,
    hiddenEye = false, hiddenCopy = false
  } = props

  const [state, setState] = useState(false)

  let inputClassName = ''
  if (!hiddenEye) {
    inputClassName += ' action-btns'

    if (hiddenCopy) inputClassName += ' action-btn'
  }

  return (
    <div className={`nx-input-password ${className}`}>
      <InputLabel
        title={title}
        htmlFor={htmlFor}
        displayEdit={displayEdit}
        onClickEdit={onClickEdit}
      />

      <div className='nx-input-password__field-container'>
        <input
          className={`nx-input-password__input ${inputClassName}`}
          type={state ? 'text' : 'password'}
          name={htmlFor}
          id={htmlFor}
          value={value}
          placeholder={placeholder}
          onChange={({ target: { value } }) => {
            onChange(value)
          }}
          required={required}
          disabled={disabled}
        />

        {
          !hiddenEye
            ? (
              <div className="nx-input-password__action-btns">
                {
                  hiddenCopy
                    ? null
                    : (
                      <IconButton
                        onClick={() => {
                          if (navigator?.clipboard?.writeText) {
                            navigator.clipboard.writeText(value)

                            SaveToastNotification.ok({
                              text: 'dashboard_copy_text'
                            })
                          }
                        }}
                        fontSize='18px'
                        className='action-btn-icons'
                      >
                        <CopyIcon size='inherit' />
                      </IconButton>

                    )
                }
                <IconButton
                  onClick={() => setState(!state)}
                  fontSize='18px'
                  className='action-btn-icons'
                >
                  {
                    state
                      ? <EyeSlashIcon size='inherit' />
                      : <EyeIcon size='inherit' />
                  }
                </IconButton>
              </div>
            )
            : null
        }
      </div>
    </div>
  )
}

export default InputPassword
